import request from '@/utils/request';
/* 列表 */
export function goodsCommentList(data) {
  return request({
    url: '/goods/evaluate/queryGoodsEvaluatePageList',
    method: 'POST',
    data
  });
}
/* 回复 */
export function goodsCommentReply(data) {
  return request({
    url: '/goods/evaluate/updateMerchantContent',
    method: 'POST',
    data
  });
}
/* 自评 */
export function goodsCommentAdd(data) {
  return request({
    url: '/goods/evaluate/saveWebGoodsEvaluate',
    method: 'POST',
    data
  });
}
/* 添加自评时获取已上架的商品列表 */
export function goodsCommentInfo(data) {
  return request({
    url: '/goods/evaluate/querySaleGoodsList',
    method: 'POST',
    data
  });
}
/* 删除 */
export function goodsCommentDel(data) {
  return request({
    url: '/goods/evaluate/removeWebGoodsEvaluateById',
    method: 'POST',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/goodsComment.js